<template>
  <svg height="100" width="100">
    <circle cx="12" cy="12" r="11" stroke="#bdbdbd" stroke-width="1" fill="white" />
    <text x="8" y="15" font-size="0.4em" fill="black">LD</text>
  </svg>
</template>

<script>
export default {
  name: "LDIcon"
};
</script>